import { FieldHelperProps, useField as useFormikField } from 'formik';
import { useRef } from 'react';

// NOTE: Reimplementing Formik's useField hook to minimize unnecessary field rerenders. Formik's
// hook recreates the field helpers on each render, causing all child components of any component
// using the hook to rerender needlessly
// https://github.com/jaredpalmer/formik/issues/2268
export const useField: typeof useFormikField = (propsOrFieldName) => {
  const [field, meta, helpers] = useFormikField(propsOrFieldName);
  const latest = useRef<FieldHelperProps<any>>(helpers);
  const stable = useRef<FieldHelperProps<any>>({
    setError: (value: any) => latest.current.setError(value),
    setTouched: (value: boolean) => latest.current.setTouched(value),
    setValue: (value: any) => latest.current.setValue(value),
  });

  latest.current.setError = helpers.setError;
  latest.current.setTouched = helpers.setTouched;
  latest.current.setValue = helpers.setValue;

  return [field, meta, stable.current];
};
